import React from 'react';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import LabelWithTooltip from '../../common/components/LabelWithTooltip';
import ui from '../../common/services/ui';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ButtonToolbar } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faHandshake } from '@fortawesome/free-regular-svg-icons';

const List = ({ childId, t, ...rest }) => {
	const columns = [
		{
			header: t('SelfAssessmentForm_Name'),
			accessor: 'form.name',
			sortable: true,
			cell: (name) => t(`AssessmentForm_SelfAssessment_${name}`)
		}
	];
	if (!childId || childId === 0) {
		columns.push(
			{
				header: t('SelfAssessments_Parent'),
				accessor: 'parent.fullname',
				cell: (parent, row) => {
					return <Link to={`/parents/${row.parent.id}`} > {row.parent.fullname}</Link>;
				},
				sortable: true
			});
		columns.push(
			{
				header: t('SelfAssessments_Child'),
				accessor: 'child.fullname',
				cell: (child, row) => {
					return <Link to={`/parents/${row.parent.id}/children/${row.child.id}`} >
						{row.child.fullname} {row.childHasEnrolmentInTerm ? <LabelWithTooltip id='hasLessonsTooltip' tooltip={t('PaymentHistory_HasLessonsTooltip')}><FontAwesomeIcon style={{ color: 'black' }} icon={faHandshake} /></LabelWithTooltip> : ''}
					</Link>;
				},
				sortable: true
			});
	}

	columns.push({
		header: t('SelfAssessmentForm_Status'),
		accessor: 'status',
		cell: (status) => t(`FormStatus_${status.name}`),
		sortable: true
	});
	columns.push({
		header: t('SelfAssessmentForm_Modified'),
		accessor: 'modified',
		sortable: true,
		cell: modified => ui.formatDate(modified)
	});
	columns.push({
		header: t('Common_Actions'),
		accessor: 'id',
		cell: (id, row) => {
			const completed = row.status.id === 3;
			const viewEditButton = completed &&
				<Link to={`/selfAssessments/${id}`} className='btn btn-teal' style={{ marginBottom: '5px', marginRight: '5px' }}><FontAwesomeIcon icon={faEye} /> {t('Common_View')}</Link>;

			return <ButtonToolbar>{viewEditButton}</ButtonToolbar>;
		}
	});

	return (
		<div>
			<PagedEntitiesList columns={columns} {...rest} />
		</div>
	);
};

export default withTranslation()(List);